const MemberRouter = [
  {
    path: '/member',
    name: 'member',
    component: () => import('../../views/Error.vue'),
    meta: {
      title: 'route.title.memberCenter', // 會員中心
      layout: 'mainframe',
      needAuthority: true, // 權限
    },
  },
  {
    path: '/member/info',
    name: 'info',
    component: () => import('../../views/Member/MemberInfo.vue'),
    meta: {
      title: 'route.title.memberInfo', // 會員資訊
      layout: 'mainframe',
      haveTitle: true, // 標題
      haveBreadcrumb: true, // 麵包屑
      keepAlive: false, // 缓存
      needAuthority: true, // 權限
      isBack: false,
    },
  },
  {
    path: '/member/modify',
    name: 'modify',
    component: () => import('../../views/Member/MemberModify.vue'),
    meta: {
      title: 'route.title.memberModify', // 會員資料修改
      layout: 'mainframe',
      haveTitle: true, // 標題
      haveBreadcrumb: true, // 麵包屑
      keepAlive: false, // 缓存
      needAuthority: true, // 權限
      isBack: false,
    },
  },
  {
    path: '/member/changePassword',
    name: 'changePassword',
    component: () => import('../../views/Member/ChangePassword.vue'),
    meta: {
      title: 'route.title.changePassword', // 會員密碼修改
      layout: 'mainframe',
      haveTitle: true, // 標題
      haveBreadcrumb: true, // 麵包屑
      keepAlive: false, // 缓存
      needAuthority: true, // 權限
      isBack: false,
    },
  },
  {
    path: '/member/orders',
    name: 'orders',
    component: () => import('../../views/Member/Orders.vue'),
    meta: {
      title: 'route.title.orders', // 訂單查詢
      layout: 'mainframe',
      haveTitle: true, // 標題
      haveBreadcrumb: true, // 麵包屑
      keepAlive: true, // 缓存
      needAuthority: true, // 權限
      isBack: false,
    },
  },
  {
    path: '/member/orders/:id',
    name: 'Order',
    component: () => import('../../views/Member/Order.vue'),
    meta: {
      title: 'route.title.orders', // 訂單查詢
      layout: 'mainframe',
      haveTitle: true, // 標題
      haveBreadcrumb: true, // 麵包屑
      keepAlive: false, // 缓存
      needAuthority: true, // 權限
      isBack: false,
      backIs: 'orders',
    },
  },
  {
    path: '/member/register',
    name: 'register',
    component: () => import('../../views/Member/Register.vue'),
    meta: {
      title: 'route.title.register', // 會員註冊
      layout: 'mainframe',
      haveTitle: true, // 標題
      haveBreadcrumb: false, // 麵包屑
      keepAlive: false, // 缓存
      needAuthority: false, // 權限
      isBack: false,
    },
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: () => import('../../views/Member/Forgot.vue'),
    meta: {
      title: 'route.title.forgot', // 忘記密碼
      layout: 'mainframe',
      haveTitle: false, // 標題
      haveBreadcrumb: false, // 麵包屑
      keepAlive: false, // 缓存
      needAuthority: false, // 權限
      isBack: false,
    },
  },
  {
    path: '/forgotAccount',
    name: 'forgotAccount',
    component: () => import('../../views/Member/ForgotAccount.vue'),
    meta: {
      title: 'route.title.forgotAccount', // 忘記帳號
      content: 'route.content.forgotAccount', // 請輸入申請時所填寫的信箱及電話，我們將協助您【找回帳號】，帳號會寄送至申請時所填寫的信箱。
      layout: 'mainframe',
      haveTitle: true, // 標題
      haveBreadcrumb: false, // 麵包屑
      keepAlive: false, // 缓存
      needAuthority: false, // 權限
      isBack: false,
    },
  },
];

export default MemberRouter;
